import { render } from "./newsletter.vue?vue&type=template&id=0373e137&scoped=true&ts=true"
import script from "./newsletter.vue?vue&type=script&lang=ts"
export * from "./newsletter.vue?vue&type=script&lang=ts"

import "./newsletter.vue?vue&type=style&index=0&id=0373e137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0373e137"]])

export default __exports__